import React, {useEffect, useState} from 'react';

import SpinnerDiv from "ui/SpinnerDiv";

import useModalGenerateOutcomes from "../Modals/useModalGenerateOutcomes";
import {getOutcomeSchedulingStatus, getOutcomeTerms} from "root/DataFunctions/OutcomeDataFns";
import TableOutcomeReviews from "root/Tables/TableOutcomeReviews";

const OutcomeReviewSchedulingPage = (props) =>
{
	const [ data, setData ] = useState ( { loading: true, yeardata: [] });
	const [ termData, setTermData ] = useState ( { loading: true, data: [] });

	const onSaveComplete = (result) =>
	{
		if ( result === 'saved')
		{
			getData() ;
		}
	}

	const [ renderModal, showModal ] = useModalGenerateOutcomes( ) ;

	useEffect(() => {
		getData();
	}, []);

	const getData = () =>
	{
		getOutcomeSchedulingStatus((response)=>
		{
			const yeardata = response.data;

			setData ( {yeardata: yeardata[0], loading: false}) ;

			getTermData() ;
		})
	}

	const getTermData = ( ) =>
	{
		getOutcomeTerms((response) =>
		{
			const recs = response.status.rowsAffected === 0 ? [] : response.data ;

			setTermData ({ loading: false, data : recs}) ;
		})
	}

	const showGenerateModal = ( year_term_id ) =>
	{
		showModal ( year_term_id, onSaveComplete )
	}

	const renderedComponent = () =>
	{
		let str = 'Today is within the academic year ' + data.yeardata.current_academic_year_from  + '-' ;
		str += data.yeardata.current_academic_year_to ;

		return (
			<div key='PRTablePanel' className='panel panel-default panel-base'>
				<div key='AcademicYearDiv' style={{paddingBottom: '10px'}}>{str}</div>
				<TableOutcomeReviews data={termData.data} loading={termData.loading} clickHandler={showGenerateModal}/>
				<div key='textdivs'>
					<div key='text1'style={{paddingBottom: '10px'}}>This table shows the terms for which requests have already been sent.</div>
					<div key='text2'style={{paddingBottom: '10px'}}>To send requests out for another term, click the green icon.</div>
				</div>
				{renderModal(props)}
			</div>
		)
	}

	return data.loading === true ? <SpinnerDiv/> :
		<div className="jumbotron">
			<p className="med">Outcome Review Scheduling</p>
			{ renderedComponent() }
		</div>
};

export default OutcomeReviewSchedulingPage;
